import { createApiRef } from '@backstage/core-plugin-api';
import { ResponseError } from '@backstage/errors';

const catalogUnprocessedEntitiesApiRef = createApiRef({
  id: "plugin.catalog-unprocessed-entities.service"
});
class CatalogUnprocessedEntitiesClient {
  constructor(discovery, fetchApi) {
    this.discovery = discovery;
    this.fetchApi = fetchApi;
  }
  async fetch(path, init) {
    const url = await this.discovery.getBaseUrl("catalog");
    const resp = await this.fetchApi.fetch(`${url}/${path}`, init);
    if (!resp.ok) {
      throw await ResponseError.fromResponse(resp);
    }
    return resp.status === 204 ? resp : await resp.json();
  }
  async pending() {
    return await this.fetch("entities/unprocessed/pending");
  }
  async failed() {
    return await this.fetch("entities/unprocessed/failed");
  }
  async delete(entityId) {
    await this.fetch(`entities/unprocessed/delete/${entityId}`, {
      method: "DELETE"
    });
  }
}

export { CatalogUnprocessedEntitiesClient, catalogUnprocessedEntitiesApiRef };
//# sourceMappingURL=index.esm.js.map
